import UserIcon from '@material-ui/icons/PersonPin';
import UserList from './UserList';
// import UserCreate from './UserCreate';
import UserShow from './UserShow';

export default {
    list: UserList,
    // create: UserCreate,
    edit: UserShow,
    icon: UserIcon,
};
